import $ from 'jquery';
import initializeHeadersAndMenus from './headers-and-menus';
import initializeArticleMasonry from './article-masonry';
import initializeSignupForm from './signup-form';
import initializeButtonDisable from './signup-form-button';
import initializeTwitterKeyboardNavigationDisable from './twitter-embed';
import initializeProgramAccordions from './event-program-accordion';
import initializeExpansionFields from './expansion-fields';
import { addTargetBlankToExternalLinks } from './link-tools';

$(() => {
  initializeHeadersAndMenus();
  initializeArticleMasonry();
  initializeSignupForm();
  initializeButtonDisable();
  initializeTwitterKeyboardNavigationDisable();
  initializeProgramAccordions();
  initializeExpansionFields();

  addTargetBlankToExternalLinks();
});
